export default `query getDistrict($id: ID!){
  getDistrict(id: $id){	
    id
    ghn_id
    wards {
      id
      ghn_id
      description {
        name
      }
    }
  }
}`
